import type { SkinAnalysisRecommendationProducts } from '../model/skinAnalysis/skinAnalysis';

/** The first live candidate is the same default pick used by the analysis solution. */
export function getCartRoutineProductIds(routine: SkinAnalysisRecommendationProducts): number[] {
  return [
    ...new Set(
      routine.steps.flatMap((step) => {
        const product = step.products[0];
        return product ? [product.productId] : [];
      }),
    ),
  ];
}
